// 解决360和ie兼容性
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
// require('es6-promise').polyfill()

import Vue from 'vue'
import App from './App.vue'

import axios from 'axios';
import './assets/css/element-ui.css'
import './plugins/element.js'

import './assets/css/common.css'
import './assets/less/style.less'


Vue.prototype.$http = axios
// 配置请求的根路径
axios.defaults.baseURL = ''
axios.interceptors.request.use(config => {
  return config
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
